import { PureComponent } from 'react';

import { isMacOS } from 'my-core/user-agent-utils';

import copyManager from '../copyManager';
import { copySelection, pasteContent } from '../utils';
import ToolbarButton from './ToolbarButton';

import { faCopy, faPaste } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class CopyPasteManager extends PureComponent {
  state = { hasClipboardData: copyManager.hasClipboardData() };
  componentDidMount() {
    copyManager.addChangeListener(this.handleCMChange);
  }
  componentWillUnmount() {
    copyManager.removeChangeListener(this.handleCMChange);
  }

  handleCMChange = hasClipboardData => this.setState({ hasClipboardData });

  render() {
    const { editorState, onUpdateEditorState } = this.props;
    const { hasClipboardData } = this.state;
    const selection = editorState.getSelection();
    const isMac = isMacOS();
    return (
      <>
        <ToolbarButton
          disabled={selection.isCollapsed()}
          onToggle={() => copySelection(editorState, onUpdateEditorState)}
          tooltip={`copy ${isMac ? '(⇧⌘C)' : '(Ctrl+Shift+C)'}`}
        >
          <FontAwesomeIcon icon={faCopy} />
        </ToolbarButton>
        <ToolbarButton
          disabled={!(hasClipboardData && selection.isCollapsed())}
          onToggle={() => pasteContent(editorState, onUpdateEditorState)}
          tooltip={`paste ${isMac ? '(⇧⌘V)' : '(Ctrl+Shift+V)'}`}
        >
          <FontAwesomeIcon icon={faPaste} />
        </ToolbarButton>
      </>
    );
  }
}
